var _path, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIdeaIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_512_606)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_512_606",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 1.90735e-06H20V20H0V1.90735e-06Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_512_606)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.0002 19.4141C9.13745 19.4141 8.43808 18.7147 8.43808 17.852V16.4458H11.5623V17.852C11.5623 18.7147 10.8629 19.4141 10.0002 19.4141Z",
    stroke: "#178035",
    strokeWidth: 0.7,
    strokeMiterlimit: 10,
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.699 16.4458H7.30103V14.1021H12.699V16.4458Z",
    stroke: "#178035",
    strokeWidth: 0.7,
    strokeMiterlimit: 10,
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.12946 15.2737H7.30102",
    stroke: "#178035",
    strokeWidth: 0.7,
    strokeMiterlimit: 10,
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.6989 15.2739H13.8705",
    stroke: "#178035",
    strokeWidth: 0.7,
    strokeMiterlimit: 10,
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.0755 0.586386C6.80863 0.545605 4.07364 3.24053 4.06742 6.5085C4.06418 8.21787 4.78352 9.75924 5.93696 10.844C6.81738 11.6721 7.30102 12.8381 7.30102 14.0469V14.1021H12.6989V14.0397C12.6989 12.8164 13.2133 11.6563 14.0975 10.8113C15.2282 9.7308 15.9325 8.20768 15.9325 6.52002C15.9325 3.26795 13.3172 0.626855 10.0755 0.586386Z",
    stroke: "#178035",
    strokeWidth: 0.7,
    strokeMiterlimit: 10,
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.0312 14.1021V9.02342",
    stroke: "#178035",
    strokeWidth: 0.7,
    strokeMiterlimit: 10,
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.0874 6.86309L11.6969 9.02344H8.36554L7.97504 6.86309",
    stroke: "#178035",
    strokeWidth: 0.7,
    strokeMiterlimit: 10,
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.2805 6.50854H19.4165",
    stroke: "#178035",
    strokeWidth: 0.7,
    strokeMiterlimit: 10,
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.5338 3.16772L18.6012 2.77913",
    stroke: "#178035",
    strokeWidth: 0.7,
    strokeMiterlimit: 10,
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.5336 9.84944L18.601 10.238",
    stroke: "#178035",
    strokeWidth: 0.7,
    strokeMiterlimit: 10,
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.72429 6.50854H0.588348",
    stroke: "#178035",
    strokeWidth: 0.7,
    strokeMiterlimit: 10,
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.47108 3.16772L1.40366 2.77913",
    stroke: "#178035",
    strokeWidth: 0.7,
    strokeMiterlimit: 10,
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.47108 9.84944L1.40366 10.238",
    stroke: "#178035",
    strokeWidth: 0.7,
    strokeMiterlimit: 10,
    strokeLinecap: "square"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_512_606"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIdeaIcon);
export default __webpack_public_path__ + "static/media/idea-icon.75bd13e92a23fd65cb8f23efa36a1908.svg";
export { ForwardRef as ReactComponent };